module.exports = __webpack_public_path__ + "img/planticks.0bc38404.svg";